export class ErrorDialogData {
  error!: {
    title?: string,
    message: string,
    subErrors?: string[]
  };
}

